import { render, staticRenderFns } from "./GlobusPricechecker.vue?vue&type=template&id=691b3da6&scoped=true&"
import script from "./GlobusPricechecker.vue?vue&type=script&lang=ts&"
export * from "./GlobusPricechecker.vue?vue&type=script&lang=ts&"
import style0 from "./GlobusPricechecker.vue?vue&type=style&index=0&id=691b3da6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691b3da6",
  null
  
)

export default component.exports